/**
 * Edge-safe route ↔ module permission map.
 * Used by middleware and re-exported from config (single source of truth).
 */

export const protectedRoutesRegex =
  /^(\/sales|\/orders|\/invoicing|\/accounting|\/strategic|\/cargogo-console|\/cargogo-admin|\/air-database|\/wms|\/price-inquire|\/track-and-trace)(\/.*)?$/;

/** Path prefix → backend Permission catalog module name. */
export const PATH_MODULE_RULES: ReadonlyArray<{ prefix: string; module: string }> = [
  { prefix: "/wms", module: "CargoGo Wms" },
  { prefix: "/cargogo-admin", module: "CargoGo Admin" },
  { prefix: "/air-database", module: "CargoGo Admin" },
  { prefix: "/cargogo-console", module: "CargoGo Console" },
  { prefix: "/orders", module: "Order" },
  { prefix: "/sales", module: "Sales" },
  { prefix: "/price-inquire", module: "CargoGo" },
  { prefix: "/track-and-trace", module: "CargoGo" },
  { prefix: "/invoicing", module: "Invoicing" },
  { prefix: "/accounting", module: "Accounting" },
  { prefix: "/strategic", module: "Strategic" },
];

export function requiredModuleForPath(pathname: string): string | null {
  const path = pathname.split("?")[0].split("#")[0] || "/";
  for (const rule of PATH_MODULE_RULES) {
    if (path === rule.prefix || path.startsWith(`${rule.prefix}/`)) {
      return rule.module;
    }
  }
  return null;
}
